const determineType = (showPerformances, showSingleEvents) => {
  if (showPerformances && !showSingleEvents) return 'performance';
  if (!showPerformances && showSingleEvents) return 'single_event';
  return 'all';
};

const padTo2Digits = num => num.toString().padStart(2, '0');

const formatLeporelloDate = date => {
  if (date instanceof Date) {
    return [
      date.getFullYear(),
      padTo2Digits(date.getMonth() + 1),
      padTo2Digits(date.getDate())
    ].join('');
  }
  return '';
};

const fetchLeporelloApi = async (
  requestControllerRef,
  mode,
  type,
  searchQuery,
  startDate,
  endDate,
  limit,
  offset,
  filters,
  includedProductions
) => {
  const params = new URLSearchParams();
  const results = [];
  let canLoadAll = false;

  // Add params: Mode
  params.append('emptyDays', mode === 'DAYS');

  // Add params: Post Types
  params.append('type', type);

  // Add params: Search Query
  params.append('search', searchQuery || '');

  // Add params: Start Date
  params.append('startDate', formatLeporelloDate(startDate));

  // Add params: End Date
  if (endDate) {
    params.append('endDate', formatLeporelloDate(endDate));
  }

  // Add params: Include Productions
  if (includedProductions) {
    params.append('performanceIncludeProductions', includedProductions);
  }

  // Add params: Limit/Offset (only if mode ITEMS)
  if (mode === 'ITEMS') {
    params.append('limit', limit);
    params.append('offset', offset);
  } else {
    params.append('limit', -1);
    params.append('offset', 0);
  }

  // Add params: Advanced Filters
  for (const [key, value] of Object.entries(filters)) {
    if (value && !(value instanceof Array && value.length < 1)) {
      params.append(key, value);
    }
  }

  // Fetch Leporello data
  try {
    const response = await fetch(`/wp-json/leporello/v1/items?${params.toString()}`, {
      signal: requestControllerRef?.current?.signal
    });
    if (response.status !== 200) {
      throw new Error(await response.text());
    }

    const data = await response.json();

    // Add results for return
    results.push(...data.days);

    // Add pagination status for return
    canLoadAll = data.pagination?.count + data.pagination?.offset < data.pagination?.total;
    return [results, canLoadAll];
  } catch (error) {
    return [false, false];
  }
};

export default fetchLeporelloApi;
